import * as Sentry from "@sentry/react";
import { Config } from "../config/config";
import { jwtDecode } from "jwt-decode";
import { UserModel } from "@/modules/auth/core/_models";
import axios from "axios";

export const initializeSentry = () => {
  Sentry.init({
    dsn: Config.VITE_SENTRY_DSN,
    //Data to be set to the initial scope. Initial scope can be defined either as an object or a callback function, as shown below.
    initialScope: (scope) => {
      scope.setTags({ environment: Config.VITE_APP_ENV });
      return scope;
    },
    beforeSend(event) {
      if (event.exception && event.exception.values) {
        const exceptions = event.exception.values;

        if (event.exception && event.exception.values) {
          const exceptions = event.exception.values;

          for (const exception of exceptions) {
            console.log('exception:' + exception.type )
            if (exception.type && exception.type.toLowerCase().includes("axios")) {
              return null; // Sentry'ye gönderme
            }
          }
        }
      }
      return event; 
    },
    integrations: [
      Sentry.browserTracingIntegration(),
      setUserInformation()
    ],
    // Capture 100% of the transactions
    tracesSampleRate: Config.VITE_SENTRY_TRACES_SAMPLES_RATE,
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [Config.VITE_SENTRY_TRACE_TARGETS],
    // Specifies whether this SDK should send events to Sentry. Defaults to true.
    enabled: true
  });
};

function setUserInformation() {
  return {
    name: "setUserInformation",
    setup() {
      if (localStorage.getItem('access_token') != undefined && localStorage.getItem('access_token') != null) {
        const accessToken = localStorage.getItem('access_token') ?? '';
        const user = jwtDecode<UserModel>(accessToken);
        setSentryUser({ id: user.userId, name: user.name, tenantId: user.accountId })
      }
      else {
        clearSentryUser();
      }
    },
  };
}

export const setSentryUser = (user: { id: string; name?: string; tenantId?: string }) => {
  Sentry.setUser(user); // Kullanıcı bilgilerini Sentry'ye gönder
};

export const clearSentryUser = () => {
  Sentry.setUser(null);
};

